import { render } from "./BulkStatusModal.vue?vue&type=template&id=5219b597&scoped=true&ts=true&lang=pug"
import script from "./BulkStatusModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BulkStatusModal.vue?vue&type=script&lang=ts&setup=true"

import "./BulkStatusModal.vue?vue&type=style&index=0&id=5219b597&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5219b597"]])

export default __exports__